export default __webpack_public_path__ + "static/media/danae-redes.c907c54a.jpg";